/**
 * The game object dimensions.
 */
class Dimension {
  width: number;
  height: number;

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
  }
}

export default Dimension;
